/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import { useState } from "react";

import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import ListDishes from "./files/ListDishes";
import { useAuth } from "../../auth";
import AddDish from "./files/AddDish";
import Success from "./files/Success";
import ViewDishes from "./files/ViewDish";
import DeleteDish from "./files/DeleteDish";
import CategorySuccess from "../category/files/CategorySuccess";
import EditDish from "./files/EditDish";
import { EditBasicDetailsWrapper } from "./files/EditWarpper";
import Edit from "./files/Edit";
import AddBulkDish from "./files/AddBulkDish";


const DishPage = () => {

  return (

    <Routes>
      <Route element={<Outlet />}>
        <Route
          path="/list"
          element={
            <>
              <ListDishes />
            </>
          }
        />
        <Route
          path="/add"
          element={
            <>
              <AddDish />
            </>
          }
        />
        <Route
          path="/bulk-add"
          element={
            <>
            <AddBulkDish />
            </>
          } />
          
        <Route
          path="/view/:id"
          element={
            <>
              <ViewDishes />
            </>
          }
        />
        <Route
          path="/edit/:id"
          element={
            <>
              <EditBasicDetailsWrapper />
            </>
          }
        />
        <Route
          path="/delete/:id"
          element={
            <>
              <DeleteDish />
            </>
          }
        />
        <Route
          path="/success"
          element={
            <>
              <Success />
            </>
          }
        />
        <Route
          path="/edit"
          element={
            <>
              <Edit />
            </>
          }
        />

        <Route
          path="/categorysuccess"
          element={
            <>
              <CategorySuccess />
            </>
          }
        />
        <Route index element={<Navigate to="list" />} />
      </Route>
    </Routes>
  );
};

export default DishPage;
